import type { TransferField } from "../../PreviewImportModal.types";

export const getSimpleFieldRowKey = (row: TransferField, rowIndex: number) =>
  `${row.ParentFieldId}-${row.ChildFieldId}-${rowIndex}`;
